export const FeatureName = 'workflowScheduling';
